module.exports = __webpack_public_path__ + "img/NW.87414aa8.png";